<template>
    <b-modal
        id="vehicle-import-modal"
        title-class="title-lg"
        hide-footer
        @hide="reset"
        size="md"
        centered
        content-class="import-modal-content"
    >
        <div class="vehicle-import-modal">
            <div class="mb-3">
                <label class="form-label">{{ $t('select-excel-file') }}</label>
                <input type="file" accept=".xlsx, .xls, .csv" class="form-control" @change="onFileChange"
                    ref="fileInput" />
            </div>

            <b-alert :show="error" variant="danger" class="mb-3">
                {{ error }}
            </b-alert>

            <div class="d-flex justify-content-end align-items-center gap-2 pt-3 mt-2">
                <base-button variant="secondary" @click="$bvModal.hide('vehicle-import-modal')">
                    {{ $t('cancel') }}
                </base-button>
                <base-button :loading="loading" variant="primary" @click="upload">
                    {{ $t('upload') }}
                </base-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import VehicleService from "@/services/vehicle.service";

export default {
    name: 'ImportModal',
    data() {
        return {
            file: null,
            loading: false,
            error: null,
        };
    },
    methods: {
        reset() {
            this.file = null;
            this.loading = false;
            this.error = null;
            if (this.$refs.fileInput) this.$refs.fileInput.value = null;
        },
        onFileChange(e) {
            this.error = null;
            const f = e.target.files && e.target.files[0];
            if (!f) return (this.file = null);

            const allowed = ['xlsx'];
            const ext = f.name.split('.').pop().toLowerCase();
            if (!allowed.includes(ext)) {
                this.error = this.$t('invalid-file-type') || 'Invalid file type';
                this.file = null;
                return;
            }
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (f.size > maxSize) {
                this.error = this.$t('file-size-exceeds-limit') || 'File size exceeds 10MB';
                this.file = null;
                return;
            }

            this.file = f;
        },
        async upload() {
            this.error = null;
            if (!this.file) {
                this.error = this.$t('please-select-a-file') || 'Please select a file';
                return;
            }

            this.loading = true;
            try {
                const form = new FormData();

                form.append('import-vehicles-file', this.file);

                const res = await VehicleService.upload(form);
                // emit the response so parent can refresh or display result
                this.$emit('imported', res);
                this.$bvModal.hide('vehicle-import-modal');
                this.$store.dispatch("enums/SHOW_TOASTER_POP", {
                    message: this.$t("resource-import-success"),
                    variant: "success",
                    title: this.$t("success"),
                    duration: 10000,
                    noCloseButton: false,
                });
            } catch (err) {
                this.error = (err?.response?.data?.message) || (err?.message) || (this.$t('something-went-wrong'));
                this.$store.dispatch("enums/SHOW_TOASTER_POP", {
                    message: this.error,
                    variant: "danger",
                    title: this.$t("error"),
                    duration: 10000,
                    noCloseButton: false,
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.vehicle-import-modal {
    padding: 1rem 0.5rem;
    min-width: 320px;
}
</style>

<style lang="scss">
.import-modal-content {
    margin: 1.75rem auto;
    max-width: 480px;
}
</style>
